export const model = {
    id: null,
    time: '',   
    created_at: '',
    updated_at: ''
};
